"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Card_1 = require("@dialogexe/cw-component-card/Card");
class CardList extends React.Component {
    constructor() {
        super(...arguments);
        this.getValue = (data, property) => {
            return parseInt(data[property]) ? parseInt(data[property]) : data[property];
        };
        this.sortBy = (cards) => {
            const { sorting } = this.props;
            if (sorting) {
                if (sorting.direction && sorting.direction.toLowerCase() === "desc") {
                    return cards.sort((a, b) => {
                        const first = this.getValue(a, sorting.property);
                        const second = this.getValue(b, sorting.property);
                        return sorting.property ?
                            (first > second) ? -1 : (first < second) ? 1 : 0
                            : 1;
                    });
                }
                return cards.sort((a, b) => {
                    const first = this.getValue(a, sorting.property);
                    const second = this.getValue(b, sorting.property);
                    return (first > second) ? 1 : (first < second) ? -1 : 0;
                });
            }
            else {
                return cards;
            }
        };
    }
    render() {
        const { title, link, pagination, cards } = this.props;
        const sortedCards = this.sortBy(cards);
        return (React.createElement("div", { className: "CardList" },
            React.createElement("h1", { className: "title" }, title),
            pagination.perPage ? (this.renderPaginated(sortedCards)) : (this.renderSimple(sortedCards)),
            link.title && link.url && (React.createElement("div", { className: "level is-flex-end" },
                React.createElement("a", { href: link.url, className: "show-more" },
                    React.createElement("span", null, link.title))))));
    }
    renderSimple(cards) {
        const { limit } = this.props;
        return (React.createElement("div", { className: "row is-spaced" }, cards
            .slice(0, limit).map((card, index) => (React.createElement("div", { key: index, className: "column is-lg-3 is-md-4 is-xs-6" },
            React.createElement(Card_1.Card, { alternate: true, image: card.image, title: card.title, subtitle: card.subtitle, link: card.link, openInNewWindow: card.openInNewWindow }))))));
    }
    renderPaginated(cards) {
        const { pagination } = this.props;
        const current = this.getCurrentPage();
        const pages = Math.ceil(cards.length / pagination.perPage);
        const offset = this.getCardsOffset(current);
        return (React.createElement("div", null,
            React.createElement("div", { className: "row is-spaced" }, cards.slice(offset, offset + pagination.perPage).map((card, index) => (React.createElement("div", { key: index, className: "column is-lg-3 is-md-4 is-xs-6" },
                React.createElement(Card_1.Card, { alternate: true, image: card.image, title: card.title, subtitle: card.subtitle, link: card.link, openInNewWindow: card.openInNewWindow }))))),
            this.renderPagination(this.getCurrentPage(), pages)));
    }
    renderPagination(current, pages) {
        return (React.createElement("div", { className: "paginator" },
            React.createElement("a", { className: `button is-contained ${current > 1 ? '' : 'is-disabled'}`, href: this.buildPaginatedPath(current - 1) }, "Forrige"),
            React.createElement("div", null,
                "Side ",
                current,
                " av ",
                pages),
            React.createElement("a", { className: `button is-contained ${current < pages ? '' : 'is-disabled'}`, href: this.buildPaginatedPath(current + 1) }, "Neste")));
    }
    getCurrentPage() {
        let pageParam = 1;
        if (typeof window !== 'undefined') {
            const url = new URL(window.location.href);
            pageParam = parseInt(url.searchParams.get("page"));
        }
        return pageParam > 0 ? pageParam : 1;
    }
    getCardsOffset(current) {
        const { pagination } = this.props;
        const offset = (current - 1) * pagination.perPage;
        return offset > 0 ? offset : 0;
    }
    buildPaginatedPath(page) {
        let path = '#';
        if (typeof window !== 'undefined') {
            path = `${window.location.pathname}?page=${page}`;
        }
        return path;
    }
}
exports.CardList = CardList;
exports.default = CardList;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-card-list/CardList.tsx